// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./components/Cookiebot.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/react-intl-tel-input/dist/main.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/font/SaolDisplay-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/assets/font/SaolDisplay-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../public/assets/font/SaolDisplay-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../public/assets/font/SaolDisplay-LightItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../public/assets/font/SaolDisplay-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../public/assets/font/SaolDisplay-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3Csvg width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg clipPath=%27url%28%23clip0_1688_4390%29%27%3E%3Cpath d=%27M11 3.5L6 8.5L1 3.5%27 stroke=%27black%27/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id=%27clip0_1688_4390%27%3E%3Crect width=%2712%27 height=%2712%27 fill=%27white%27/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3Csvg width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg clipPath=%27url%28%23clip0_1119_16074%29%27%3E%3Cpath d=%27M11 3.5L6 8.5L1 3.5%27 stroke=%27%23FAFAFA%27/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id=%27clip0_1119_16074%27%3E%3Crect width=%2712%27 height=%2712%27 fill=%27white%27/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Arimo:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;300;400;500&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --body-background: #fff; }

.iti-mobile .intl-tel-input.iti-container {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99999999999; }

@font-face {
  font-family: 'Saol Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap; }

@font-face {
  font-family: 'Saol Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-weight: normal;
  font-style: italic;
  font-display: swap; }

* {
  box-sizing: border-box; }

body {
  margin: 0;
  font-family: 'Arimo';
  background-color: var(--body-background); }

a {
  color: #a37c51; }

.container {
  width: calc(100% - 48px);
  margin: 0 auto; }

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Saol Display';
  font-style: normal;
  font-weight: 400;
  color: #111111; }

.primary-color {
  color: #a37c51; }

.plan .price {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  color: #111111; }

.error {
  font-family: 'Arimo';
  font-style: normal;
  font-weight: 400;
  color: #f00; }
  .error::before {
    content: '* '; }

input {
  background-color: transparent;
  border: 1px solid #dfdfdf;
  outline: none;
  box-shadow: none;
  font-family: 'Arimo';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #8f8f8f;
  padding: 18px 24px;
  width: 100%; }
  input#password {
    padding: 18px 50px 18px 24px; }
  input[type='checkbox'] {
    width: 21px;
    height: 21px;
    margin-right: 16px;
    background-color: transparent;
    border: 1px solid #dfdfdf; }

.input_password {
  position: relative; }
  .input_password .input_eye {
    position: absolute;
    top: 50%;
    bottom: 50%;
    right: 18px;
    transform: translateY(-50%); }

.input-help {
  font-family: 'Arimo';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #8f8f8f; }

select {
  appearance: none;
  height: 60px;
  background: transparent;
  border: 1px solid #dfdfdf;
  width: 100%;
  padding: 14px 16px;
  outline: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-position-x: calc(100% - 16px);
  background-position-y: 50%;
  background-repeat: no-repeat; }

.react-select-container {
  width: 100%;
  flex-shrink: 1; }
  .react-select-container .react-select__control {
    background-color: #111;
    border: 1px solid #fafafa;
    outline: 0;
    color: #fafafa;
    opacity: 0.4;
    width: 100%; }
  .react-select-container .react-select__input-container {
    color: #fff;
    overflow: hidden; }
  .react-select-container .react-select__value-container {
    padding: 12px 16px; }
  .react-select-container .react-select__menu {
    background-color: #111;
    color: #fafafa; }
  .react-select-container .react-select__option {
    opacity: 0.5; }
    .react-select-container .react-select__option.react-select__option--is-focused {
      background-color: #000; }

.filter {
  display: none; }
  .filter + .tags {
    margin-bottom: 72px; }
  .filter.show {
    display: block; }
  .filter label {
    font-family: 'Arimo';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #fafafa;
    display: inline-block;
    margin-bottom: 16px; }
  .filter select {
    appearance: none;
    width: 100%;
    background-color: #111;
    border: 1px solid #fafafa;
    opacity: 0.2;
    font-family: 'Arimo';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #fafafa;
    opacity: 0.4;
    height: 52px;
    padding: 14px 16px;
    outline: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-position-x: calc(100% - 16px);
    background-position-y: 50%;
    background-repeat: no-repeat; }
  .filter .input_group {
    flex-direction: column;
    display: flex;
    gap: 24px; }

.input_group {
  margin-bottom: 24px; }
  .input_group label {
    display: block;
    font-family: 'Arimo';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 32px;
    color: #111; }
    .input_group label .required {
      color: #a37c51; }
    .input_group label.checkbox {
      display: flex;
      font-family: 'Arimo';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #111; }
      .input_group label.checkbox a {
        color: #111; }

.label_group {
  display: flex;
  align-items: center;
  justify-content: space-between; }

.login_form label,
.reset_form label {
  color: #fff; }
  .login_form label.checkbox,
  .reset_form label.checkbox {
    color: #fff; }

.login_form .input_group label.checkbox a,
.reset_form .input_group label.checkbox a {
  color: #a37c51; }

.login_form input,
.reset_form input {
  background-color: rgba(216, 216, 216, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.3);
  font-family: 'Arimo';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  padding: 19px 24px; }
  .login_form input[type='checkbox'],
  .reset_form input[type='checkbox'] {
    width: 17px;
    height: 21px;
    margin-right: 12px;
    background-color: #ffffff;
    border: 1px solid #979797;
    border-radius: 5px; }

.layout.account {
  margin-bottom: 30%; }
  .layout.account .container-half {
    max-width: 792px;
    width: calc(100% - 32px);
    margin: 0 auto; }

.layout.landing .logo.mobile {
  display: none !important; }

.layout.landing .logo.desktop {
  display: block !important; }

.layout.landing .nav-links {
  display: block !important; }

.layout .sticky-button {
  display: none;
  padding: 105px 0 48px;
  text-align: right; }
  .layout .sticky-button .button {
    position: fixed;
    bottom: 45px;
    right: 120px; }

.logo.desktop {
  display: none; }

.logo.mobile {
  display: block; }

.policy-page {
  padding-top: 150px;
  padding-bottom: 100px; }
  .policy-page.container {
    width: 60%;
    color: #f1f1f1; }
  .policy-page h1 {
    color: #fff;
    font-family: 'Saol Display';
    font-size: 64px;
    text-align: center;
    margin-bottom: 100px; }
  .policy-page h4 {
    color: #fff;
    font-family: 'Saol Display';
    font-size: 35px; }
  .policy-page p {
    font-family: 'Arimo';
    font-size: 18px; }

.intl-tel-input {
  width: 100%; }

#fc_frame,
#fc_frame.fc-widget-normal {
  z-index: 99999999999999 !important; }

@media screen and (max-width: 768px) {
  #fc_frame,
  #fc_frame.fc-widget-normal {
    bottom: 100px !important; }
  .container.withPadding {
    padding-left: 0 !important;
    padding-right: 0 !important; }
  .policy-page.container {
    width: 100%;
    padding: 100px 24px; }
  .policy-page h1 {
    font-size: 60px; }
  .input_group {
    width: 100% !important; }
  form .wrapper {
    width: calc(100% - 32px); }
  [type='checkbox'] {
    padding: 10px; } }

@media screen and (min-width: 768px) {
  .logo.desktop {
    display: block; }
  .logo.mobile {
    display: none; }
  .layout.account {
    margin-bottom: 0; }
  .layout .sticky-button {
    display: block; }
  .container {
    width: 90%; }
  .filter .input_group {
    flex-direction: row; }
  .filter:not(.show) {
    display: block; }
  .toggleFilters {
    display: none !important; } }

@media screen and (min-width: 1024px) {
  .container {
    width: 960px; }
  .container-half {
    width: 100%; } }

@media screen and (min-width: 1200px) {
  .container {
    width: 1140px; } }

@media screen and (min-width: 1600px) {
  .container {
    width: 1320px; } }
`, "",{"version":3,"sources":["webpack://./src/assets/scss/App.scss"],"names":[],"mappings":"AAAA;EACE,uBAAkB,EAAA;;AAQpB;EACE,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,oBAAoB,EAAA;;AAOtB;EACE,2BAA2B;EAC3B,4CAA6D;EAC7D,oHAE0E;EAC1E,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,2BAA2B;EAC3B,4CAAmE;EACnE,oHAGkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB,EAAA;;AAIpB;EACE,sBAAsB,EAAA;;AAGxB;EACE,SAAS;EAET,oBAAoB;EACpB,wCAAwC,EAAA;;AAG1C;EACE,cAAc,EAAA;;AAGhB;EACE,wBAAwB;EACxB,cAAc,EAAA;;AAIhB;;;;;;EAME,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAGhB,cAAc,EAAA;;AAGhB;EACE,cAAc,EAAA;;AAGhB;EAEI,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc,EAAA;;AAKlB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW,EAAA;EAJb;IAOI,aAAa,EAAA;;AAIjB;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAEhB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EAEjB,cAAc;EAEd,kBAAkB;EAClB,WAAW,EAAA;EAfb;IAkBI,4BAA4B,EAAA;EAlBhC;IAsBI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAElB,6BAA6B;IAC7B,yBAAyB,EAAA;;AAI7B;EACE,kBAAkB,EAAA;EADpB;IAII,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,WAAW;IAEX,2BAA2B,EAAA;;AAI/B;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAEhB,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EAEX,kBAAkB;EAElB,aAAa;EAEb,yDAAsX;EACtX,wCAAwC;EACxC,0BAA0B;EAC1B,4BAA4B,EAAA;;AAG9B;EACE,WAAW;EACX,cAAc,EAAA;EAFhB;IAKI,sBAAsB;IACtB,yBAAyB;IACzB,UAAU;IACV,cAAc;IACd,YAAY;IACZ,WAAW,EAAA;EAVf;IAaI,WAAW;IACX,gBAAgB,EAAA;EAdpB;IAkBI,kBAAkB,EAAA;EAlBtB;IAsBI,sBAAsB;IACtB,cAAc,EAAA;EAvBlB;IA2BI,YAAY,EAAA;IA3BhB;MA8BM,sBAAsB,EAAA;;AAK5B;EAEE,aAAa,EAAA;EAFf;IAKI,mBAAmB,EAAA;EALvB;IASI,cAAc,EAAA;EATlB;IAaI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IAEd,qBAAqB;IACrB,mBAAmB,EAAA;EArBvB;IAyBI,gBAAgB;IAEhB,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;IAEZ,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,YAAY;IAEZ,YAAY;IAEZ,kBAAkB;IAElB,aAAa;IAEb,yDAA4X;IAC5X,wCAAwC;IACxC,0BAA0B;IAC1B,4BAA4B,EAAA;EAnDhC;IAuDI,sBAAsB;IACtB,aAAa;IACb,SAAS,EAAA;;AAIb;EACE,mBAAmB,EAAA;EADrB;IAII,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW,EAAA;IAVf;MAaM,cAAc,EAAA;IAbpB;MAiBM,aAAa;MAEb,oBAAoB;MACpB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,WAAW,EAAA;MAxBjB;QA2BQ,WAAW,EAAA;;AAMnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B,EAAA;;AAGhC;;EAGI,WAAW,EAAA;EAHf;;IAMM,WAAW,EAAA;;AANjB;;EAWI,cAAc,EAAA;;AAXlB;;EAeI,2CAA2C;EAC3C,0CAA0C;EAC1C,+BAA+B;EAE/B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EAEjB,kBAAkB,EAAA;EAzBtB;;IA4BM,WAAW;IACX,YAAY;IACZ,kBAAkB;IAElB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB,EAAA;;AAMxB;EAQI,kBAAkB,EAAA;EARtB;IAGM,gBAAgB;IAChB,wBAAwB;IACxB,cAAc,EAAA;;AALpB;EAcQ,wBAAwB,EAAA;;AAdhC;EAkBQ,yBAAyB,EAAA;;AAlBjC;EAuBM,yBAAyB,EAAA;;AAvB/B;EA4BI,aAAa;EACb,qBAAqB;EACrB,iBAAiB,EAAA;EA9BrB;IAiCM,eAAe;IACf,YAAY;IACZ,YAAY,EAAA;;AAKlB;EAEI,aAAa,EAAA;;AAFjB;EAMI,cAAc,EAAA;;AAKlB;EACE,kBAAkB;EAClB,qBAAqB,EAAA;EAFvB;IAKI,UAAU;IACV,cAAc,EAAA;EANlB;IAUI,WAAW;IACX,2BAA2B;IAC3B,eAAe;IAEf,kBAAkB;IAClB,oBAAoB,EAAA;EAfxB;IAmBI,WAAW;IACX,2BAA2B;IAC3B,eAAe,EAAA;EArBnB;IAyBI,oBAAoB;IACpB,eAAe,EAAA;;AAKnB;EACE,WAAW,EAAA;;AAIb;;EAEE,kCAAkC,EAAA;;AAIpC;EACE;;IAEE,wBAAwB,EAAA;EAG1B;IAEI,0BAA0B;IAC1B,2BAA2B,EAAA;EAI/B;IAEI,WAAW;IACX,mBAAmB,EAAA;EAHvB;IAOI,eAAe,EAAA;EAInB;IACE,sBAAsB,EAAA;EAGxB;IACE,wBAAwB,EAAA;EAtJ1B;IA0JE,aAAa,EAAA,EACd;;AAGH;EACE;IAEI,cAAc,EAAA;EAFlB;IAMI,aAAa,EAAA;EAIjB;IAEI,gBAAgB,EAAA;EAFpB;IAMI,cAAc,EAAA;EAIlB;IACE,UAAU,EAAA;EAGZ;IAEI,mBAAmB,EAAA;EAFvB;IAMI,cAAc,EAAA;EAGlB;IACE,wBAAwB,EAAA,EACzB;;AAGH;EACE;IACE,YAAY,EAAA;EAGd;IACE,WAAW,EAAA,EACZ;;AAGH;EACE;IACE,aAAa,EAAA,EACd;;AAGH;EACE;IACE,aAAa,EAAA,EACd","sourcesContent":[":root {\n  --body-background: #fff;\n}\n\n// Components\n@import url('./components/Cookiebot.scss');\n\n// React CSS Imports\n@import url('~react-intl-tel-input/dist/main.css');\n.iti-mobile .intl-tel-input.iti-container {\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 99999999999;\n}\n\n// Fonts\n@import url('https://fonts.googleapis.com/css2?family=Arimo:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;300;400;500&display=swap');\n\n@font-face {\n  font-family: 'Saol Display';\n  src: url('../../../public/assets/font/SaolDisplay-Light.eot');\n  src: url('../../../public/assets/font/SaolDisplay-Light.woff2')\n      format('woff2'),\n    url('../../../public/assets/font/SaolDisplay-Light.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Saol Display';\n  src: url('../../../public/assets/font/SaolDisplay-LightItalic.eot');\n  src: url('../../../public/assets/font/SaolDisplay-LightItalic.woff2')\n      format('woff2'),\n    url('../../../public/assets/font/SaolDisplay-LightItalic.woff')\n      format('woff');\n  font-weight: normal;\n  font-style: italic;\n  font-display: swap;\n}\n\n//\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n\n  font-family: 'Arimo';\n  background-color: var(--body-background);\n}\n\na {\n  color: #a37c51;\n}\n\n.container {\n  width: calc(100% - 48px);\n  margin: 0 auto;\n}\n\n// Typography\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: 'Saol Display';\n  font-style: normal;\n  font-weight: 400;\n  // font-size: 32px;\n  // line-height: 24px;\n  color: #111111;\n}\n\n.primary-color {\n  color: #a37c51;\n}\n\n.plan {\n  .price {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 24px;\n    line-height: 24px;\n    color: #111111;\n  }\n}\n\n// Form Components\n.error {\n  font-family: 'Arimo';\n  font-style: normal;\n  font-weight: 400;\n  color: #f00;\n\n  &::before {\n    content: '* ';\n  }\n}\n\ninput {\n  background-color: transparent;\n  border: 1px solid #dfdfdf;\n  outline: none;\n  box-shadow: none;\n\n  font-family: 'Arimo';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n\n  color: #8f8f8f;\n\n  padding: 18px 24px;\n  width: 100%;\n\n  &#password {\n    padding: 18px 50px 18px 24px;\n  }\n\n  &[type='checkbox'] {\n    width: 21px;\n    height: 21px;\n    margin-right: 16px;\n\n    background-color: transparent;\n    border: 1px solid #dfdfdf;\n  }\n}\n\n.input_password {\n  position: relative;\n\n  .input_eye {\n    position: absolute;\n    top: 50%;\n    bottom: 50%;\n    right: 18px;\n\n    transform: translateY(-50%);\n  }\n}\n\n.input-help {\n  font-family: 'Arimo';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: #8f8f8f;\n}\n\nselect {\n  appearance: none;\n\n  height: 60px;\n  background: transparent;\n  border: 1px solid #dfdfdf;\n  width: 100%;\n\n  padding: 14px 16px;\n\n  outline: none;\n\n  background-image: url(\"data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clipPath='url(%23clip0_1688_4390)'%3E%3Cpath d='M11 3.5L6 8.5L1 3.5' stroke='black'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_1688_4390'%3E%3Crect width='12' height='12' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A\");\n  background-position-x: calc(100% - 16px);\n  background-position-y: 50%;\n  background-repeat: no-repeat;\n}\n\n.react-select-container {\n  width: 100%;\n  flex-shrink: 1;\n\n  .react-select__control {\n    background-color: #111;\n    border: 1px solid #fafafa;\n    outline: 0;\n    color: #fafafa;\n    opacity: 0.4;\n    width: 100%;\n  }\n  .react-select__input-container {\n    color: #fff;\n    overflow: hidden;\n  }\n\n  .react-select__value-container {\n    padding: 12px 16px;\n  }\n\n  .react-select__menu {\n    background-color: #111;\n    color: #fafafa;\n  }\n\n  .react-select__option {\n    opacity: 0.5;\n\n    &.react-select__option--is-focused {\n      background-color: #000;\n    }\n  }\n}\n\n.filter {\n  // margin-bottom: 72px;\n  display: none;\n\n  + .tags {\n    margin-bottom: 72px;\n  }\n\n  &.show {\n    display: block;\n  }\n\n  label {\n    font-family: 'Arimo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    color: #fafafa;\n\n    display: inline-block;\n    margin-bottom: 16px;\n  }\n\n  select {\n    appearance: none;\n\n    width: 100%;\n    background-color: #111;\n    border: 1px solid #fafafa;\n    opacity: 0.2;\n\n    font-family: 'Arimo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    color: #fafafa;\n    opacity: 0.4;\n\n    height: 52px;\n\n    padding: 14px 16px;\n\n    outline: none;\n\n    background-image: url(\"data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clipPath='url(%23clip0_1119_16074)'%3E%3Cpath d='M11 3.5L6 8.5L1 3.5' stroke='%23FAFAFA'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_1119_16074'%3E%3Crect width='12' height='12' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A\");\n    background-position-x: calc(100% - 16px);\n    background-position-y: 50%;\n    background-repeat: no-repeat;\n  }\n\n  .input_group {\n    flex-direction: column;\n    display: flex;\n    gap: 24px;\n  }\n}\n\n.input_group {\n  margin-bottom: 24px;\n\n  label {\n    display: block;\n    font-family: 'Arimo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 32px;\n    color: #111;\n\n    .required {\n      color: #a37c51;\n    }\n\n    &.checkbox {\n      display: flex;\n\n      font-family: 'Arimo';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 18px;\n      color: #111;\n\n      a {\n        color: #111;\n      }\n    }\n  }\n}\n\n.label_group {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.login_form,\n.reset_form {\n  label {\n    color: #fff;\n\n    &.checkbox {\n      color: #fff;\n    }\n  }\n\n  .input_group label.checkbox a {\n    color: #a37c51;\n  }\n\n  input {\n    background-color: rgba(216, 216, 216, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    color: rgba(255, 255, 255, 0.3);\n\n    font-family: 'Arimo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 32px;\n\n    padding: 19px 24px;\n\n    &[type='checkbox'] {\n      width: 17px;\n      height: 21px;\n      margin-right: 12px;\n\n      background-color: #ffffff;\n      border: 1px solid #979797;\n      border-radius: 5px;\n    }\n  }\n}\n\n// Account Layout\n.layout {\n  &.account {\n    .container-half {\n      max-width: 792px;\n      width: calc(100% - 32px);\n      margin: 0 auto;\n    }\n\n    margin-bottom: 30%;\n  }\n\n  &.landing {\n    .logo {\n      &.mobile {\n        display: none !important;\n      }\n\n      &.desktop {\n        display: block !important;\n      }\n    }\n\n    & .nav-links {\n      display: block !important;\n    }\n  }\n\n  .sticky-button {\n    display: none;\n    padding: 105px 0 48px;\n    text-align: right;\n\n    .button {\n      position: fixed;\n      bottom: 45px;\n      right: 120px;\n    }\n  }\n}\n\n.logo {\n  &.desktop {\n    display: none;\n  }\n\n  &.mobile {\n    display: block;\n  }\n}\n\n// Privacy Policy Page\n.policy-page {\n  padding-top: 150px;\n  padding-bottom: 100px;\n\n  &.container {\n    width: 60%;\n    color: #f1f1f1;\n  }\n\n  h1 {\n    color: #fff;\n    font-family: 'Saol Display';\n    font-size: 64px;\n\n    text-align: center;\n    margin-bottom: 100px;\n  }\n\n  h4 {\n    color: #fff;\n    font-family: 'Saol Display';\n    font-size: 35px;\n  }\n\n  p {\n    font-family: 'Arimo';\n    font-size: 18px;\n  }\n}\n\n// Intl Tel Input\n.intl-tel-input {\n  width: 100%;\n}\n\n// Freshchat\n#fc_frame,\n#fc_frame.fc-widget-normal {\n  z-index: 99999999999999 !important;\n}\n\n// Media Queries\n@media screen and (max-width: 768px) {\n  #fc_frame,\n  #fc_frame.fc-widget-normal {\n    bottom: 100px !important;\n  }\n\n  .container {\n    &.withPadding {\n      padding-left: 0 !important;\n      padding-right: 0 !important;\n    }\n  }\n\n  .policy-page {\n    &.container {\n      width: 100%;\n      padding: 100px 24px;\n    }\n\n    h1 {\n      font-size: 60px;\n    }\n  }\n\n  .input_group {\n    width: 100% !important;\n  }\n\n  form .wrapper {\n    width: calc(100% - 32px);\n  }\n\n  &[type='checkbox'] {\n    padding: 10px;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .logo {\n    &.desktop {\n      display: block;\n    }\n\n    &.mobile {\n      display: none;\n    }\n  }\n\n  .layout {\n    &.account {\n      margin-bottom: 0;\n    }\n\n    & .sticky-button {\n      display: block;\n    }\n  }\n\n  .container {\n    width: 90%;\n  }\n\n  .filter {\n    .input_group {\n      flex-direction: row;\n    }\n\n    &:not(.show) {\n      display: block;\n    }\n  }\n  .toggleFilters {\n    display: none !important;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .container {\n    width: 960px;\n  }\n\n  .container-half {\n    width: 100%;\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .container {\n    width: 1140px;\n  }\n}\n\n@media screen and (min-width: 1600px) {\n  .container {\n    width: 1320px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
